import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { task, timeout } from 'ember-concurrency';

export default class AdminSignOutRoute extends Route {
  // Services
  @service session;

  // Hooks
  beforeModel() {
    return this.delayedInvalidate.perform();
  }

  // Functions
  delayedInvalidate = task(async () => {
    await timeout(2000);

    return this.session.invalidate();
  });
}
